import { EBAY, ETSY, FAIRE, SHOPIFY } from './channels';

export const CONTENT_TYPE = {
  CSV: 'text/csv',
  JSON: 'application/json',
  TEXT: 'text/plain',
};

export const HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  EXPIRES: 'Expires',
  CONTENT_DISPOSITION: 'Content-Disposition',
};

export const TARGET_TYPE = {
  VIDEO: 'video',
  THUMBNAIL: 'thumbnail',
};

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
};

export const ENDPOINT = {
  AUTH: `${process.env.AUTH_API_ENDPOINT}/api/v1`,
  AUTH_V2: `${process.env.AUTH_API_ENDPOINT}/api/v2`,
  AUTH_V3: `${process.env.AUTH_API_ENDPOINT}/api/v3`,
  ASSETS: process.env.ASSETS_ENDPOINT,
  AWS_S3_FILES: `https://${process.env.AWS_FILES_BUCKET_NAME}`,
  AWS_S3_IMAGES: `https://s3.amazonaws.com/${process.env.AWS_IMAGES_BUCKET_NAME}`,
  AWS_S3_THUMBNAILS: `https://${process.env.AWS_THUMBNAILS_BUCKET_NAME}`,
  AWS_S3_VIDEOS: `https://${process.env.AWS_VIDEOS_BUCKET_NAME}`,
  BULK_OVERRIDE: process.env.BULK_OVERRIDE_ENDPOINT,
  CONNECT_CHANNEL: {
    [EBAY]: `${process.env.WEB_API_ENDPOINT}/api/v2/ebay/getUserAuth`,
    [ETSY]: `${process.env.WEB_API_ENDPOINT}/auth/etsy`,
    [FAIRE]: `${process.env.WEB_API_ENDPOINT}/api/v2/faire/getUserAuth`,
    [SHOPIFY]: `${process.env.WEB_API_ENDPOINT}/shopifyAppStore`,
  },
  ACTIVATE_VELA_CHANNEL: {
    [EBAY]: 'https://signup.ebay.com/pa/crte',
    [ETSY]: 'https://www.etsy.com/join',
    [FAIRE]: 'https://www.faire.com/brands',
    [SHOPIFY]: 'https://accounts.shopify.com/signup',
  },
  CSV: process.env.CSV_API_ENDPOINT,
  IMAGE_GROUPING: process.env.IMAGE_GROUPING_API_ENDPOINT,
  LOGOUT: `${process.env.WEB_API_ENDPOINT}/logout`,
  SCHEDULED_UPDATES: process.env.SCHEDULED_UPDATES_API_ENDPOINT,
  SCHEDULED_LISTINGS: process.env.SCHEDULED_LISTINGS_API_ENDPOINT,
  TAXONOMY: process.env.TAXONOMY_ENDPOINT,
  UPDATE_TOKEN: `${process.env.WEB_API_ENDPOINT}/auth/shopify`,
  WEB: `${process.env.WEB_API_ENDPOINT}/api/v1`,
  WEB_V2: `${process.env.WEB_API_ENDPOINT}/api/v2`,
  WEB_V3: `${process.env.WEB_API_ENDPOINT}/api/v3`,
};

export const ERROR_KEYS = [
  'message',
  'error_message',
  'error',
  'reason',
  'data',
];
